import React from 'react';

/**
 * RegisterForm - 注册表单组件
 */
export function RegisterForm({
  userType,
  formData,
  error,
  success,
  isSubmitting,
  canSendCode,
  verifyButtonLabel,
  onUserTypeChange,
  onChange,
  onGetCode,
  onSubmit,
  onSwitchToLogin,
}) {
  return (
    <div className="register-form-container">
      {/* 用户类型选择 */}
      <div className="form-type-tabs">
        <button 
          className={`form-type-tab ${userType !== 'enterprise' ? 'active' : ''}`}
          onClick={() => onUserTypeChange('individual')}
        >
          个人用户注册
        </button>
        <button 
          className={`form-type-tab ${userType === 'enterprise' ? 'active' : ''}`}
          onClick={() => onUserTypeChange('enterprise')}
        >
          企业用户注册
        </button>
      </div>
      
      <form onSubmit={onSubmit} className="register-form">
        {/* 错误提示 */}
        {error && <div className="form-error">{error}</div>}
        {success && <div className="form-success">{success}</div>}

        {/* 用户名 */}
        <div className="form-row">
          <label className="form-label">用户名 *</label>
          <input
            type="text"
            name="username"
            placeholder="用户名必须3-30个字符"
            value={formData.username}
            onChange={onChange}
            className="form-input-field"
            required
          />
        </div>
        
        {/* 密码 */}
        <div className="form-row">
          <label className="form-label">密码 *</label>
          <input
            type="password"
            name="password"
            placeholder="至少6位，包含字母和数字"
            value={formData.password}
            onChange={onChange}
            className="form-input-field"
            required
          />
        </div>
        
        {/* 真实姓名 */}
        <div className="form-row">
          <label className="form-label">真实姓名 *</label>
          <input
            type="text"
            name="name"
            placeholder="请填写真实姓名"
            value={formData.name}
            onChange={onChange}
            className="form-input-field"
            required
          />
        </div>
        
        {/* 职位 */}
        <div className="form-row">
          <label className="form-label">职位 *</label>
          <input
            type="text"
            name="position"
            placeholder="例如：经理、工程师"
            value={formData.position}
            onChange={onChange}
            className="form-input-field"
            required
          />
        </div>
        
        {/* 企业名称（企业用户必填） */}
        {userType === 'enterprise' && (
          <div className="form-row">
            <label className="form-label">企业名称 *</label>
            <input
              type="text"
              name="company"
              placeholder="请填写完整企业名称"
              value={formData.company}
              onChange={onChange}
              className="form-input-field"
              required
            />
          </div>
        )}
        
        {/* 手机号 */}
        <div className="form-row">
          <label className="form-label">手机号 *</label>
          <input
            type="tel"
            name="phone"
            placeholder="请填写手机号"
            value={formData.phone}
            onChange={onChange}
            className="form-input-field"
            required
          />
        </div>
        
        {/* 验证码 */}
        <div className="form-row">
          <label className="form-label">验证码 *</label>
          <div className="verify-row">
            <input
              type="text"
              name="verifyCode"
              placeholder="短信验证码"
              value={formData.verifyCode}
              onChange={onChange}
              className="form-input-field verify-input"
              required
            />
            <button
              type="button"
              onClick={onGetCode}
              className="verify-button"
              disabled={!canSendCode}
            >
              {verifyButtonLabel}
            </button>
          </div>
        </div>
        
        {/* 邮箱（选填） */}
        <div className="form-row">
          <label className="form-label">邮箱</label>
          <input
            type="email"
            name="email"
            placeholder="选填，用于接收通知"
            value={formData.email}
            onChange={onChange}
            className="form-input-field"
          />
        </div>
        
        {/* 企业资质（企业用户选填） */}
        {userType === 'enterprise' && (
          <div className="form-row">
            <label className="form-label">企业资质(附件)</label>
            <input
              type="text"
              name="credentials"
              placeholder="选填，如营业执照编号"
              value={formData.credentials}
              onChange={onChange}
              className="form-input-field"
            />
          </div>
        )}
        
        {/* 服务协议 */}
        <div className="form-terms">
          <label className="terms-label">
            <input
              type="checkbox"
              name="agreeTerms"
              checked={formData.agreeTerms}
              onChange={onChange}
              required
            />
            <span>
              我已阅读并同意 <a href="/terms" target="_blank">《用户服务协议》</a> 及 <a href="/privacy" target="_blank">《隐私政策》</a>
            </span>
          </label>
        </div>
        
        {/* 提交按钮 */}
        <button 
          type="submit" 
          className="submit-button" 
          disabled={isSubmitting}
        >
          {isSubmitting ? '注册中...' : '注册'}
        </button>
        
        {/* 切换到登录 */}
        <div className="switch-link">
          已有账号？
          <a href="#" onClick={(e) => { e.preventDefault(); onSwitchToLogin(); }}>
            立即登录
          </a>
        </div>
      </form>
    </div>
  );
}

